/* eslint-disable max-len */
/* eslint-disable no-unused-vars */

import { PolymerElement } from "@polymer/polymer/polymer-element.js";
import template from "./boxed-layout.html";

import { FlattenedNodesObserver } from "@polymer/polymer/lib/utils/flattened-nodes-observer.js";

/**
 * <p>The boxed-layout creates a grid with the main content boxed at a max width of 1366px.
 *    after that it will just leave whitespace on either side.</p>
 *
 * <demo-snippet class="demoSnippet">
 *   <template>
 *     <style>
 *       h2, h3 { grid-column: span 12 }
 *       .grid {
 *         border: 1px dashed var(--color-expressive-3);
 *         padding: 10px 25px;
 *       }
 *       article {
 *         background-color: var(--color-expressive-2);
 *         padding: 10px 25px;
 *       }
 *     </style>
 *     <boxed-layout>
 *       <div class="grid">
 *         <h2>This is the main content in the boxed-layout</h2>
 *         <p>test 1</p>
 *         <p>test 2</p>
 *         <p>test 3</p>
 *         <p>test 4</p>
 *         <p>test 5</p>
 *         <p>test 6</p>
 *         <p>test 7</p>
 *         <p>test 8</p>
 *         <p>test 9</p>
 *         <p>test 10</p>
 *         <p>test 11</p>
 *         <p>test 12</p>
 *       </div>
 *       <article class="fullbleed">
 *         <h3>Putting a class of 'fullbleed' on a container will break it out of the
 *             inner 12 column grid and force it to go fullbleed within its parent</h3>
 *       </article>
 *       <div class='grid'>
 *         <h3>Adding a class of 'grid' will automatically give a container a 12 column grid within the main boxed content</h3>
 *       </div>
 *     </boxed-layout>
 *   </template>
 * </demo-snippet>
 *
 */
export class BoxedLayout extends PolymerElement {
  constructor() {
    super();
  }

  static get is() {
    return "boxed-layout";
  }

  static get template() {
    let htmlElement = document.createElement("TEMPLATE");
    htmlElement.innerHTML = template;
    return htmlElement;
  }

  static get properties() {
    return {
      /**
       * List of distributed children used to calculate the fullbleed effect
       */
      _distNodeList: {
        type: Array,
        value: []
      }
    };
  }

  ready() {
    super.ready();
  }

  /**
   * When connected we need to observe the distributed children so we can calculate
   * any that have a class of 'fullbleed'
   */
  connectedCallback() {
    super.connectedCallback();
    window.addEventListener("resize", (e) => {
      clearTimeout(resizeTimer);
      let resizeTimer = setTimeout(() => {
        this._processNewNodes(
          this._distNodeList.filter((node) => {
            return node.nodeType === Node.ELEMENT_NODE;
          })
        );
      }, 100);
    });
    // window.onresize = () => {
    //     console.log('need to recalc distributed nodes when resized');
    // }
    this._distNodesObserver = new FlattenedNodesObserver(this, (info) => {
      this._processNewNodes(
        info.addedNodes.filter((node) => {
          return node.nodeType === Node.ELEMENT_NODE;
        })
      );
      // this._processRemovedNodes(info.removedNodes);
    });
  }

  /**
   * If the element is disconnected for some reason we need to also disconnect the observer
   */
  disconnectedCallback() {
    super.disconnectedCallback();
    this._distNodesObserver.disconnect();
  }

  /**
   * For each node in the flattened node tree look for those with a class of 'fullbleed'
   * and break them out of the grid.
   * TODO: there may be a css way or more elegant way of doing this.
   * @param {*} nodeList
   */
  _processNewNodes(nodeList) {
    if (!this._distNodeList.length) this._distNodeList = nodeList;
    for (const key in nodeList) {
      if (nodeList.hasOwnProperty(key)) {
        const node = nodeList[key];
        if (node.className) {
          if (node.className.includes("fullbleed")) {
            let container = node.parentElement.parentElement;
            if (container.getBoundingClientRect().width > 1366) {
              node.style.marginLeft =
                "-" +
                (container.getBoundingClientRect().width - 1366) / 2 +
                "px";
              node.style.width = container.getBoundingClientRect().width + "px";
            } else {
              node.style.marginLeft =
                "-" +
                (node.parentElement.parentElement.getBoundingClientRect()
                  .width -
                  node.parentElement.getBoundingClientRect().width) /
                  2 +
                "px";
              node.style.width = container.getBoundingClientRect().width + "px";
            }
          }
        }
      }
    }
  }
}
customElements.define(BoxedLayout.is, BoxedLayout);
